export const VIDEO_ASSET_TYPE = 'video';
export const IMAGE_ASSET_TYPE = 'image';
